import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card } from 'react-bootstrap';
import Carousel from 'react-multi-carousel';

const NewMovies = () => {
  const [movies, setMovies] = useState([]);
  const [breakpoint, setBreakpoint] = useState('desktop');

const responsive = {
  superLargeDesktop: { breakpoint: { max: 4000, min: 3000 }, items: 4 },
  desktop:           { breakpoint: { max: 3000, min: 1024 }, items: 4 },
  tablet:            { breakpoint: { max: 1024, min: 464 }, items: 4 },
  mobile:            { breakpoint: { max: 464, min: 0 }, items: 2 }
};


  useEffect(() => {
    const getBreakpoint = (width) => {
      if (width >= 3000) return 'superLargeDesktop';
      if (width >= 1024) return 'desktop';
      if (width >= 464) return 'tablet';
      return 'mobile';
    };

    const handleResize = () => {
      setBreakpoint(getBreakpoint(window.innerWidth));
    };

    handleResize(); // set initial value
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const fetchMovies = async () => {
      try {
        const response = await fetch('https://second-team-productions.onrender.com/newmovies');
        if (!response.ok) {
          throw new Error('Failed to fetch movies');
        }
        const data = await response.json();
        const filteredMovies = data.filter(movie => movie.moviename !== 'SEVEN SAMURAI' && movie.moviename !== 'SHARED FATE');
        setMovies(filteredMovies);
      } catch (error) {
        console.error('Error fetching movies:', error);
      }
    };

    fetchMovies();
  }, []);

return (
  <div style={{ display: 'flex', justifyContent: 'center', width: '100%', overflowX: 'hidden' }}>
    <div style={{ position: 'relative', width: 'clamp(320px, 90vw, 1600px)' }}>
      <h2 className="d-flex justify-content-left" style={{ marginLeft: '1%' }}>
        New Movies
      </h2>

      <Carousel 
      key={breakpoint} 
      responsive={responsive} 
      infinite={false} 
      autoPlay={false}
        containerClass="movie-carousel-container"
  itemClass="movie-carousel-item"
      >
        {movies.map((movie) => (
          <div
            key={movie.id}
            style={{
              padding: '0rem 0',
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <Card className="custom-border" style={{ margin: '0 5px' }}>
              <Link to={`/${movie.moviename}`}>
                <Card.Img
                  variant="top"
                  src={movie.posterimage}
                  alt={movie.moviename}
                  className="card-img"
                  style={{
                    border: '1px solid rgba(255, 255, 255, 0.03)',
                    boxShadow: `
                      0 2px 0 rgba(255, 255, 255, 0.03) inset,
                      0 -2px 0 rgba(0, 0, 0, 0.5) inset,
                      0 12px 24px rgba(0, 0, 0, 0.6),
                      0 32px 64px rgba(0, 0, 0, 0.5),
                      0 64px 100px rgba(0, 0, 0, 0.35)
                    `,
                  }}
                />
              </Link>
            </Card>
          </div>
        ))}
      </Carousel>
    </div>
  </div>
);
};

export default NewMovies;
